function config() {
    this.timesync_host = 'https://teszt.digital-report-socket-time.mksz.hu';
    this.timesync_port = 443;
    this.socket_host = 'https://teszt.digital-report-socket.mksz.hu';
    this.socket_port = 443;
    this.socket_debug = true;

    this.loginmethod = "backoffice";

    this.sentry_dsn = false;
}

module.exports = new config();
